var exports = {
  "k": "x0a7806d5--7fe6a6--container",
};

module.exports = exports;
